import { InvalidStateDescriptorTypeError } from '../errors';
export var StateDescriptorTypeModel;
(function (StateDescriptorTypeModel) {
    StateDescriptorTypeModel[StateDescriptorTypeModel["Account"] = 64] = "Account";
    StateDescriptorTypeModel[StateDescriptorTypeModel["Validator"] = 72] = "Validator";
})(StateDescriptorTypeModel || (StateDescriptorTypeModel = {}));
const isStateDescriptorType = (value) => StateDescriptorTypeModel[value] !== undefined;
export const assertStateDescriptorType = (value) => {
    if (isStateDescriptorType(value)) {
        return value;
    }
    throw new InvalidStateDescriptorTypeError(value);
};

//# sourceMappingURL=StateDescriptorTypeModel.js.map
